import { API } from "../../api";
async function client_policy(request) {
    // console.log("client_policy -> request", request);
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `/v2/client/policy`,
        authorization: process.env.LETS_TRADE_CLIENT_TOKEN,
    });
}
export { client_policy };
